export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-background-100 rounded-2xl p-6 md:p-10">
          <div className="flex-shrink-0">
            <div className="w-32 h-32 md:w-40 md:h-40 rounded-3xl bg-primary-500/10 flex items-center justify-center">
              <i className="ri-smartphone-line text-5xl md:text-6xl text-primary-500"></i>
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">移动客户端</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl">
              91视频网站移动端适配全面完成，支持手机与平板设备随时随地观看91国产视频。界面简洁流畅，加载速度快，让您在地铁、咖啡厅或家中都能畅享91年国产影片与热门剧集的高清观影体验。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mt-5">
              <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-50 border border-background-200 text-sm font-medium text-foreground-700 cursor-pointer whitespace-nowrap">
                <i className="ri-android-line text-primary-500"></i>
                Android 版
              </span>
              <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-50 border border-background-200 text-sm font-medium text-foreground-700 cursor-pointer whitespace-nowrap">
                <i className="ri-apple-line text-primary-500"></i>
                iOS 版
              </span>
              <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-50 border border-background-200 text-sm font-medium text-foreground-700 cursor-pointer whitespace-nowrap">
                <i className="ri-computer-line text-primary-500"></i>
                PC 客户端
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}